import React from "react";
import PropTypes from "prop-types";
import PopulationFrequenciesHeaders from "./PopulationFrequenciesHeaders";
import PopulationFrequenciesTotalTable from "./PopulationFrequenciesTotalTable";
import Histograms from "../../GnomadHistogram/Histograms";
import { getHistogramsData } from "./helpers";
import PopulationsFrequenciesBody from "./PopulationFrequenciesBody";

const PopulationsFrequenciesTable = ({
  item,
  isMito,
  gnomadType,
  filterFailed,
}) => {
  const { ageHistHetData, ageHistHomData } = getHistogramsData(item);
  return (
    <div>
      <table
        className={`varsome-table-overflow ${
          filterFailed ? "tw-opacity-30" : ""
        }`}
      >
        <PopulationFrequenciesHeaders
          nonpar={item?.nonpar}
          isMito={isMito}
          gnomadType={gnomadType}
        />
        <PopulationsFrequenciesBody item={item} isMito={isMito} />
        <PopulationFrequenciesTotalTable item={item} isMito={isMito} />
      </table>
      <Histograms
        ageHistHetData={ageHistHetData}
        ageHistHomData={ageHistHomData}
        nonpar={item?.nonpar}
        isMito={isMito}
        gnomadType={gnomadType}
        filterFailed={filterFailed}
      />
    </div>
  );
};

PopulationsFrequenciesTable.propTypes = {
  item: PropTypes.shape({
    nonpar: PropTypes.number,
    an_female: PropTypes.number,
    an_male: PropTypes.number,
    ac: PropTypes.number,
    af: PropTypes.number,
    an: PropTypes.number,
    ac_hom: PropTypes.number,
    ac_het: PropTypes.number,
    nhomalt: PropTypes.number,
  }),
  isMito: PropTypes.bool,
  filterFailed: PropTypes.bool,
  gnomadType: PropTypes.string,
};

PopulationsFrequenciesTable.defaultProps = {
  item: {},
  isMito: false,
  filterFailed: false,
  gnomadType: null,
};
export default PopulationsFrequenciesTable;
